const serverUrl =  process.env.REACT_APP_ENV === 'production' ? 'https://mesajussu.turkcell.com.tr/api/api' : 'http://127.0.0.1:8080/api'; // LOCAL SERVER
//const mobileConnectProd = {clientId:"TURKCELL_MESAJ_USSU", calbackUrl: "https://mesajussu.turkcell.com.tr/api/api/users/mobCon/callback"}  ; // LOCAL SERVER
//const mobileConnectTest =  {clientId:"TURKCELL_MESAJ_USSU", calbackUrl: "https://mesajussu.turkcell.com.tr/api/api/users/mobCon/callback"} ; // LOCAL SERVER
const mobileConnectProd =  {clientId:"TURKCELL_MESAJ_USSU", calbackUrl: "https://mesajussu.turkcell.com.tr/api/api/users/mobCon/callback"} ; // LOCAL SERVER
//const mobileConnectLocal =  {clientId:"TURKCELL_MESAJ_USSU", calbackUrl: "http://127.0.0.1:8080/api/users/mobCon/callback"} ; // LOCAL SERVER
const paycellRedirectUrl = process.env.REACT_APP_ENV === 'production' ? 'https://epayment.turkcell.com.tr/paymentmanagement/rest/threeDSecure' : 'https://omccstb.turkcell.com.tr/paymentmanagement/rest/threeDSecure'; //TEST
const paycellCallbackUrl = process.env.REACT_APP_ENV === 'production' ? 'https://mesajussu.turkcell.com.tr/api/api/omcc/threeDResultCallBack' : 'http://localhost:8080/api/omcc/threeDResultCallBack'; //TEST

const uiURL = process.env.REACT_APP_ENV === 'production' ? 'https://mesajussu.turkcell.com.tr/' : 'https://mesajussu-stb.turkcell.com.tr/'; //TEST

let mainConfiguration;

if (process.env.REACT_APP_ENV === 'production') {
    mainConfiguration = {
       serverUrl:'https://mesajussu.turkcell.com.tr/api/api',
       mobileConnect : {clientId:"TURKCELL_MESAJ_USSU", calbackUrl: "https://mesajussu.turkcell.com.tr/api/api/users/mobCon/callback"},
       paycellRedirectUrl : 'https://epayment.turkcell.com.tr/paymentmanagement/rest/threeDSecure',
       paycellCallbackUrl : 'https://mesajussu.turkcell.com.tr/api/api/omcc/threeDResultCallBack',
       uiURL : 'https://mesajussu.turkcell.com.tr/'
    };
} else if (process.env.REACT_APP_ENV === 'test') {
   mainConfiguration = {
       serverUrl:'https://mesajussu-stb.turkcell.com.tr/api/api',
       mobileConnect : {clientId:"TURKCELL_MESAJ_USSU", calbackUrl: "https://mesajussu-stb.turkcell.com.tr/api/api/users/mobCon/callback"},
       paycellRedirectUrl : 'https://omccstb.turkcell.com.tr/paymentmanagement/rest/threeDSecure',
       paycellCallbackUrl : 'https://mesajussu-stb.turkcell.com.tr/api/api/omcc/threeDResultCallBack',
       uiURL : 'https://mesajussu-stb.turkcell.com.tr/'
   };
}  else  {
   mainConfiguration = {
       serverUrl:'http://localhost:8080/api',
       mobileConnect : {clientId:"TURKCELL_MESAJ_USSU", calbackUrl: "http://192.168.0.113:8080/api/users/mobCon/callback"},
       paycellRedirectUrl : 'https://omccstb.turkcell.com.tr/paymentmanagement/rest/threeDSecure',
       paycellCallbackUrl : 'https://mesajussu-stb.turkcell.com.tr/api/api/omcc/threeDResultCallBack',
       uiURL : 'http://localhost:8080/api/omcc/threeDResultCallBack'
   };
}

//https://hizligiris.com.tr/hizligiris/oauth/authorize?client_id=AdenonTest&scope=phone%20email%20profile%20openid&redirect_uri=https://mesajussu.turkcell.com.tr/api/api/users/mobCon/callback&response_type=code&state=State.j47J1KjrcG46HPN2OwTOz2AqteLkY3xSoonRiJoZpGd5YNk5v_DYm1rWt0AlE4Ql3N0lkMnrbI2ECAw_2lNnyaP&nonce=Nonce.vZH9YwSK62cI60LSeB9A7Cmy-MWKrWAAMKXv5Xmd3eePtm4DCA2dDqnPN-I35W71Ocx9LZRDbpbAW_BHh_zq8Jf&prompt=login&acr_values=3&display=page&ui_locales=tr&claims_locales=tr
module.exports = {
  clientId: 'web',
  serverUrl: mainConfiguration.serverUrl,
  mobileConnect:mainConfiguration.mobileConnect,
  paycellRedirectUrl:mainConfiguration.paycellRedirectUrl,
  paycellCallbackUrl:mainConfiguration.paycellCallbackUrl,
  uiURL:mainConfiguration.uiURL
};